import { useTranslation } from "react-i18next";

import { Logo } from "@app/components/AdminNavbar/components/Logo";
import { MailIcon } from "lucide-react";
import "../i18n";

export default function SustainabilityCenterFooter({
    locale,
}: {
    locale: string;
}) {
    const { t } = useTranslation("SustainabilityCenter", {
        lng: locale,
    });

    return (
        <div className="mt-5 flex justify-center items-center self-stretch pt-11 pb-30 bg-secondary border-t border-secondary">
            <div className="flex w-[1120px] items-start gap-8">
                <div className="flex w-[300px] flex-col items-start shrink-0">
                    <a
                        className="flex flex-col items-end cursor-pointer no-underline"
                        href="https://www.trustditto.com/"
                        target="_blank"
                    >
                        <Logo className="h-4" />
                    </a>
                </div>
                <div className="flex flex-col items-start gap-5">
                    <div className="text-sm"> {t("about")}</div>
                    <div className="flex font-bold text-green gap-2 items-center">
                        <MailIcon className="w-5" />
                        <a
                            className="text-green font-bold text-base"
                            href="https://www.trustditto.com/contact"
                            target="_blank"
                        >
                            {t("contact")}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
